import {combineReducers} from 'redux';
import byId from './by-id';
import idList from './id-list';
import isLoaded from './is-modal-loaded';
import proxyActions from './proxy-actions';

export const reducerForApp = {
  modal: combineReducers({
    byId,
    idList,
    isLoaded,
  }),
  proxyActions,
};
